import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../store';

import {
	selectDatasetnumber,
	selectDatasetnumber2, selectIsOnesided,
	selectLdt1,
	selectLdt2, selectLePolar, selectLePolar2, selectMountingInstruction,
	selectPolar,
	selectPolar2, selectSpcConfiguration,
	selectUlor,
	selectUlor2
} from '../../selectors';
import {filterAndJoin} from '../../util/filterAndJoin';
import {pimText, pimTextDebug} from '../../util/values';

@customElement('shared-polar-diagram')
export class SharedPolarDiagram extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: block;
			container-type: inline-size;
		}

		a {
			color: #000;
		}

		.text {
			font: var(--font-specsheet-print-small-text);
			font-size: 5cqw;
		}

		.image {
			margin-bottom: 15cqw;
		}
		img {
			width: 100%;
			display: block;
			padding: 0 15cqw 0 0;
			box-sizing: border-box;
		}

    `
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.productData = this.state.productData;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}

	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.spcConfiguration, this.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.spcConfiguration, this.productData.translations, value, prefix, suffix, '', false);
	}

	render() {
		const s = this.state;
		return html`

			<div class="col">
				<div class="image">
					${when(selectPolar(s), () => html`<img src="${selectPolar(s)}" alt="polar">`)}
					${when(selectLePolar(s), () => html`<img src="${selectLePolar(s)}" alt="polar">`)}
					<div class="text">
						${msg('Light point')} 1<br><br>
						LED ${filterAndJoin([
							this.t('LE_ColourTemperature_1', 'FV.S'),
							this.t('LE_LightDistribution_1', 'FV.S'),
							this.t('EB_MotionSensor_1', 'FV.L'),
						], ', ')}
						<br>
						${when(selectDatasetnumber(s), () => html`<trans-label key="LE_LightEngineDataset" context="D"></trans-label>: ${selectDatasetnumber(s)}<br/>`)}
						${when(selectUlor(s), () => html`<trans-label key="LU_ULOR" context="D.L"></trans-label>: ${selectUlor(s)} %<br/>`)}
						${when(selectLdt1(s), () => html`<br><a href="${selectLdt1(s)}" target="_blank">${msg('LDT')} 1</a><br>`)}
						${when(selectMountingInstruction(this.state) !== null, () => html`<a href="${selectMountingInstruction(this.state)}" target="_blank">${msg('Mounting instruction')}</a><br>`)}
					</div>
				</div>

				${when((selectPolar2(s) !== null || selectLePolar2(s) !== null), () => html`
					<div class="image">
						${when(selectPolar2(s), () => html`<img src="${selectPolar2(s)}" alt="polar">`)}
						${when(selectLePolar2(s), () => html`<img src="${selectLePolar2(s)}" alt="polar">`)}
						<div class="text">
							${msg('Light point')} 2<br><br>
							LED ${filterAndJoin([
								this.t('LE_ColourTemperature_2', 'FV.S'),
								this.t('LE_LightDistribution_2', 'FV.S'),
								this.t('EB_MotionSensor_2', 'FV.L'),
							], ', ')}
							<br>
							${when(selectDatasetnumber2(s), () => html`<trans-label key="LE_LightEngineDataset" context="D"></trans-label>: ${selectDatasetnumber2(s)}<br/>`)}
							${when(selectUlor2(s), () => html`<trans-label key="LU_ULOR" context="D.L"></trans-label>: ${selectUlor2(s)} %<br/>`)}
							${when(selectLdt2(s), () => html`<br><a href="${selectLdt2(s)}" target="_blank">${msg('LDT')} 2</a>`)}
						</div>
					</div>
				`)}
			</div>

		`;
	}
}
